import type { Document } from "@/types/documents";

export type SortKey = "name" | "created_at" | "modified_at" | "size" | "type" | "user";
export type SortOrder = "asc" | "desc";

export function sortDocuments(
  documents: Document[],
  sortKey: SortKey,
  sortOrder: SortOrder
): Document[] {
  const sorted = [...documents].sort((a, b) => {
    let result = 0;

    if (sortKey === "name") {
      result = a.filename.localeCompare(b.filename);
    } else if (sortKey === "created_at") {
      // When the file reached Franklin — the column the server sorts the same
      // key on (repository/queries.ts), so a folder sorted here agrees with List.
      result = Date.parse(a.created_at) - Date.parse(b.created_at);
    } else if (sortKey === "modified_at") {
      // Use document_content_modified_date when available, fallback to original_created_at, then created_at
      const dateA = new Date(
        a.document_content_modified_date || a.original_created_at || a.created_at
      ).getTime();
      const dateB = new Date(
        b.document_content_modified_date || b.original_created_at || b.created_at
      ).getTime();
      result = dateA - dateB;
    } else if (sortKey === "size") {
      const sizeA = Number(a.size) || 0;
      const sizeB = Number(b.size) || 0;
      result = sizeA - sizeB;
    } else if (sortKey === "type") {
      result = a.content_type.localeCompare(b.content_type);
    } else if (sortKey === "user") {
      result = (a.created_by_name ?? "").localeCompare(b.created_by_name ?? "");
    }

    const finalResult = sortOrder === "asc" ? result : -result;
    return finalResult;
  });

  return sorted;
}
